import { cn } from "@/lib/utils";

interface LoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
}

export function LoadingState({ 
  size = "md", 
  fullScreen = false,
  className,
  ...props 
}: LoadingStateProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  return (
    <div 
      className={cn(
        "flex flex-col items-center justify-center gap-2",
        fullScreen && "min-h-screen bg-background",
        className
      )}
      {...props}
    >
      <div className={cn(
        "animate-spin rounded-full border-b-2 border-primary",
        sizeClasses[size]
      )} />
      <p className="text-muted-foreground text-sm">Loading...</p>
    </div>
  );
}